<div class="card m-0 bg-transparent">
  <div class="card-body">
    <h5
      *ngIf="config?.title"
      class="card-title text-start offcanvas-header-text mb-3"
    >
      <ng-container *ngIf="config?.title_text">
        {{ config?.title_text }}
      </ng-container>
      <ng-container *ngIf="!config?.title_text">
        {{ os_name }} Main Settings
      </ng-container>
    </h5>
    <ng-container *ngIf="config?.icon || config?.trailing_icon || config?.text">
      <div class="row mb-4">
        <ng-container *ngIf="config?.icon">
          <div
            class="me-auto"
            [ngClass]="
              config?.icon && config?.trailing_icon
                ? 'col-6'
                : 'col-3 pe-0 order-first'
            "
          >
            <label class="offcanvas-header-text w-100" style="text-align: left">
              {{
                config?.icon && !config?.trailing_icon ? "Icon" : "Leading Icon"
              }}
            </label>
            <div
              class="input-group offcanvas-border-primary border rounded-2"
              title="Using format option"
            >
              <button
                type="button"
                class="form-control input-lg offcanvas-primary border-0 d-flex align-items-center justify-content-center"
                (click)="openSelector(selectorIcons, 0)"
              >
                <i
                  class="fs-4"
                  [class]="
                    icon?.type == 'mir'
                      ? 'material-icons-outlined'
                      : 'material-icons'
                  "
                >
                  {{ icon?.id }}
                </i>
              </button>
              <button
                type="button"
                class="btn offcanvas-primary dropdown-toggle dropdown-toggle-split border-0"
                (click)="openSelector(selectorIcons, 0)"
              >
                <i class="mdi mdi-chevron-down"></i>
              </button>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="config?.trailing_icon_2">
          <div
            [ngClass]="
              config?.icon && config?.trailing_icon_2
                ? 'col-6'
                : 'col-3 ps-0 order-last'
            "
          >
            <label class="offcanvas-header-text w-100" style="text-align: left">
              {{
                !config?.icon && config?.trailing_icon_2
                  ? "Icon 2"
                  : "Trailing Icon 2"
              }}
            </label>
            <div
              class="input-group offcanvas-border-primary border rounded-2"
              title="Using format option"
            >
              <button
                type="button"
                class="form-control input-lg offcanvas-primary border-0 d-flex align-items-center justify-content-center"
                (click)="openSelector(selectorIcons, 2)"
              >
                <i
                  class="fs-4"
                  [class]="
                    trailing_icon_2?.type == 'mir'
                      ? 'material-icons-outlined'
                      : 'material-icons'
                  "
                >
                  {{ trailing_icon_2?.id }}
                </i>
              </button>
              <button
                type="button"
                class="btn offcanvas-primary dropdown-toggle dropdown-toggle-split border-0"
                (click)="openSelector(selectorIcons, 2)"
              >
                <i class="mdi mdi-chevron-down"></i>
              </button>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="config?.trailing_icon">
          <div
            [ngClass]="
              config?.icon && config?.trailing_icon
                ? 'col-6'
                : 'col-3 ps-0 order-last'
            "
          >
            <label class="offcanvas-header-text w-100" style="text-align: left">
              {{
                !config?.icon && config?.trailing_icon
                  ? "Icon"
                  : "Trailing Icon"
              }}
            </label>
            <div
              class="input-group offcanvas-border-primary border rounded-2"
              title="Using format option"
            >
              <button
                type="button"
                class="form-control input-lg offcanvas-primary border-0 d-flex align-items-center justify-content-center"
                (click)="openSelector(selectorIcons, 1)"
              >
                <i
                  class="fs-4"
                  [class]="
                    trailing_icon?.type == 'mir'
                      ? 'material-icons-outlined'
                      : 'material-icons'
                  "
                >
                  {{ trailing_icon?.id }}
                </i>
              </button>
              <button
                type="button"
                class="btn offcanvas-primary dropdown-toggle dropdown-toggle-split border-0"
                (click)="openSelector(selectorIcons, 1)"
              >
                <i class="mdi mdi-chevron-down"></i>
              </button>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="config?.text">
          <div
            [ngClass]="
              config?.icon && config?.trailing_icon
                ? 'col-12 w-100 order-first mb-3'
                : config?.icon || (config?.trailing_icon && !config?.trailing_icon_2)
                ? 'col-9'
                : (config?.trailing_icon && config?.trailing_icon_2) ? 'col-6' : 'col-12 w-100 order-first'
            "
          >
            <label
              for="text-color"
              class="offcanvas-header-text w-100"
              style="text-align: left"
            >
              {{ config?.name }}
            </label>
            <div
              class="input-group offcanvas-border-primary border rounded-2"
              title="Using format option"
            >
              <form class="needs-validation w-100" [formGroup]="labelform">
                <input
                  *ngIf="!config?.text_area"
                  type="text"
                  id="lablecolor"
                  formControlName="lableControl"
                  class="form-control input-lg offcanvas-primary border-0"
                  [value]="button_text"
                  (change)="buttonLabel()"
                  placeholder="Label"
                  [ngClass]="{ 'is-invalid': f.lableControl.errors }"
                />
                <textarea
                  *ngIf="config?.text_area"
                  name="lableControl"
                  id="lableControl"
                  formControlName="lableControl"
                  class="form-control input-lg offcanvas-primary border-0"
                  [value]="button_text"
                  placeholder="Label"
                  rows="6"
                  (change)="buttonLabel()"
                  [ngClass]="{ 'is-invalid': f.lableControl.errors }"
                ></textarea>
                <div *ngIf="f.lableControl.errors" class="invalid-feedback">
                  <span *ngIf="f.lableControl.errors.required">
                    Field is required
                  </span>
                  <span *ngIf="f.lableControl.errors.maxlength">
                    Actual length is
                    {{ f.lableControl.errors.maxlength.actualLength }} required
                    not more than
                    {{ f.lableControl.errors.maxlength.requiredLength }}
                    chars.
                  </span>
                </div>
              </form>
            </div>
          </div>
        </ng-container>
      </div>
    </ng-container>
    <ng-container *ngIf="config?.format && (button?.button_value_type?.input == 'number' || button?.button_value_type?.input == 'double')">
      <form [formGroup]="formatform">
        <div class="row">
          <div class="mb-3 col-6">
            <label
              for="prefix"
              class="offcanvas-header-text w-100"
              style="text-align: left"
            >
              Prefix
            </label>
            <input
              type="text"
              id="prefix"
              class="form-control offcanvas-primary ng-pristine ng-valid ng-touched border-0 shadow-none"
              formControlName="prefix"
              (change)="updateFormatForm()"
            />
          </div>
          <div class="mb-3 col-6">
            <label
              for="suffix"
              class="offcanvas-header-text w-100"
              style="text-align: left"
            >
              Suffix
            </label>
            <input
              type="text"
              id="suffix"
              class="form-control offcanvas-primary ng-pristine ng-valid ng-touched border-0 shadow-none"
              formControlName="suffix"
              (change)="updateFormatForm()"
            />
          </div>
        </div>
      </form>
    </ng-container>
    <div class="row mb-3" *ngIf="config?.font">
      <div class="col-12 w-100 d-flex flex-column align-items-start">
        <label class="offcanvas-header-text" style="text-align: left">
          Font Size
        </label>
        <div
          class="btn-group"
          role="group"
          aria-label="Basic radio toggle button group"
          *ngIf="!config?.font_option || config?.font_option == 3"
        >
          <input
            type="radio"
            class="btn-check offcanvas-btn-check"
            [name]="'btnradiofont' + button?.button_id + fontID"
            [id]="'font6' + button?.button_id + fontID"
            autocomplete="off"
            [checked]="fontSize === 'xxs'"
            (change)="updateFontSize('xxs')"
          />
          <label class="btn" [for]="'font6' + button?.button_id + fontID">
            XXS
          </label>
          <input
            type="radio"
            class="btn-check offcanvas-btn-check"
            [name]="'btnradiofont' + button?.button_id + fontID"
            [id]="'font4' + button?.button_id + fontID"
            autocomplete="off"
            [checked]="fontSize === 'xs'"
            (change)="updateFontSize('xs')"
          />
          <label class="btn" [for]="'font4' + button?.button_id + fontID">
            XS
          </label>
          <input
            type="radio"
            class="btn-check offcanvas-btn-check"
            [name]="'btnradiofont' + button?.button_id + fontID"
            [id]="'font3' + button?.button_id + fontID"
            autocomplete="off"
            [checked]="fontSize === 'sm'"
            (change)="updateFontSize('sm')"
          />
          <label class="btn" [for]="'font3' + button?.button_id + fontID">
            SM
          </label>
          <input
            type="radio"
            class="btn-check offcanvas-btn-check"
            [name]="'btnradiofont' + button?.button_id + fontID"
            [id]="'font1' + button?.button_id + fontID"
            autocomplete="off"
            [checked]="fontSize === 'md'"
            (change)="updateFontSize('md')"
          />
          <label class="btn" [for]="'font1' + button?.button_id + fontID">
            MD
          </label>
          <input
            type="radio"
            class="btn-check offcanvas-btn-check"
            [name]="'btnradiofont' + button?.button_id + fontID"
            [id]="'font2' + button?.button_id + fontID"
            autocomplete="off"
            [checked]="fontSize === 'lg'"
            (change)="updateFontSize('lg')"
          />
          <label class="btn" [for]="'font2' + button?.button_id + fontID">
            LG
          </label>
          <input
            type="radio"
            class="btn-check offcanvas-btn-check"
            [name]="'btnradiofont' + button?.button_id + fontID"
            [id]="'font5' + button?.button_id + fontID"
            autocomplete="off"
            [checked]="fontSize === 'xl'"
            (change)="updateFontSize('xl')"
          />
          <label class="btn" [for]="'font5' + button?.button_id + fontID">
            XL
          </label>
          <input
            type="radio"
            class="btn-check offcanvas-btn-check"
            [name]="'btnradiofont' + button?.button_id + fontID"
            [id]="'font7' + button?.button_id + fontID"
            autocomplete="off"
            [checked]="fontSize === 'xxl'"
            (change)="updateFontSize('xxl')"
          />
          <label class="btn" [for]="'font7' + button?.button_id + fontID">
            XXL
          </label>
        </div>
        <div
          class="btn-group"
          role="group"
          aria-label="Basic radio toggle button group"
          *ngIf="config?.font_option && config?.font_option == 7"
        >
          <input
            type="radio"
            class="btn-check offcanvas-btn-check"
            [name]="'btnradiofont' + button?.button_id + fontID"
            [id]="'font6' + button?.button_id + fontID"
            autocomplete="off"
            [checked]="fontSize === 'xxs'"
            (change)="updateFontSize('xxs')"
          />
          <label class="btn" [for]="'font6' + button?.button_id + fontID"
            >XXS</label
          >
          <input
            type="radio"
            class="btn-check offcanvas-btn-check"
            [name]="'btnradiofont' + button?.button_id + fontID"
            [id]="'font7' + button?.button_id + fontID"
            autocomplete="off"
            [checked]="fontSize === 'xs'"
            (change)="updateFontSize('xs')"
          />
          <label class="btn" [for]="'font7' + button?.button_id + fontID"
            >XS</label
          >
          <input
            type="radio"
            class="btn-check offcanvas-btn-check"
            [name]="'btnradiofont' + button?.button_id + fontID"
            [id]="'font3' + button?.button_id + fontID"
            autocomplete="off"
            [checked]="fontSize === 'sm'"
            (change)="updateFontSize('sm')"
          />
          <label class="btn" [for]="'font3' + button?.button_id + fontID"
            >SM</label
          >
          <input
            type="radio"
            class="btn-check offcanvas-btn-check"
            [name]="'btnradiofont' + button?.button_id + fontID"
            [id]="'font1' + button?.button_id + fontID"
            autocomplete="off"
            [checked]="fontSize === 'md'"
            (change)="updateFontSize('md')"
          />
          <label class="btn" [for]="'font1' + button?.button_id + fontID"
            >MD</label
          >
          <input
            type="radio"
            class="btn-check offcanvas-btn-check"
            [name]="'btnradiofont' + button?.button_id + fontID"
            [id]="'font2' + button?.button_id + fontID"
            autocomplete="off"
            [checked]="fontSize === 'lg'"
            (change)="updateFontSize('lg')"
          />
          <label class="btn" [for]="'font2' + button?.button_id + fontID"
            >LG</label
          >
          <input
            type="radio"
            class="btn-check offcanvas-btn-check"
            [name]="'btnradiofont' + button?.button_id + fontID"
            [id]="'font4' + button?.button_id + fontID"
            autocomplete="off"
            [checked]="fontSize === 'xl'"
            (change)="updateFontSize('xl')"
          />
          <label class="btn" [for]="'font4' + button?.button_id + fontID"
            >XL</label
          >
          <input
            type="radio"
            class="btn-check offcanvas-btn-check"
            [name]="'btnradiofont' + button?.button_id + fontID"
            [id]="'font5' + button?.button_id + fontID"
            autocomplete="off"
            [checked]="fontSize === 'xxl'"
            (change)="updateFontSize('xxl')"
          />
          <label class="btn" [for]="'font5' + button?.button_id + fontID"
            >XXL</label
          >
        </div>
      </div>
    </div>
    <div class="row" *ngIf="config?.align">
      <div class="col-12 w-100 d-flex flex-column align-items-start">
        <label class="offcanvas-header-text" style="text-align: left">
          Text Alignment :: {{ text_id }}
        </label>
        <div
          class="btn-group"
          role="group"
          aria-label="Basic radio toggle button group"
        >
          <input
            type="radio"
            class="btn-check offcanvas-btn-check"
            [name]="'alignment' + button?.button_id + alginID"
            [id]="'alignment1' + button?.button_id + alginID"
            autocomplete="off"
            [checked]="textAlign === 'left'"
            (change)="updateLapleAlignmet('left')"
          />
          <label
            class="btn fw-bold mb-0 d-flex align-items-center justify-content-center"
            [for]="'alignment1' + button?.button_id + alginID"
            ><i class="material-icons">format_align_left</i></label
          >

          <input
            type="radio"
            class="btn-check offcanvas-btn-check"
            [name]="'alignment' + button?.button_id + alginID"
            [id]="'alignment2' + button?.button_id + alginID"
            autocomplete="off"
            [checked]="textAlign === 'center'"
            (change)="updateLapleAlignmet('center')"
          />
          <label
            class="btn fw-bold mb-0 d-flex align-items-center justify-content-center"
            [for]="'alignment2' + button?.button_id + alginID"
            ><i class="material-icons">format_align_center</i></label
          >

          <input
            type="radio"
            class="btn-check offcanvas-btn-check"
            [name]="'alignment' + button?.button_id + alginID"
            [id]="'alignment3' + button?.button_id + alginID"
            autocomplete="off"
            [checked]="textAlign === 'right'"
            (change)="updateLapleAlignmet('right')"
          />
          <label
            class="btn fw-bold mb-0 d-flex align-items-center justify-content-center"
            [for]="'alignment3' + button?.button_id + alginID"
            ><i class="material-icons">format_align_right</i></label
          >
        </div>
      </div>
    </div>
    <div *ngIf="config?.setcolor" class="row" [class.mt-4]="config?.text">
      <label
        for="bg-color"
        class="offcanvas-header-text col-9 m-0 d-flex align-items-center"
        style="text-align: left"
      >
        {{ config?.name }} Tint
      </label>
      <div *ngIf="!enableCustomColor" class="col-3 d-flex justify-content-end">
        <btn class="btn btn-primary" (click)="toggle(true)">SET</btn>
      </div>
      <ng-container *ngIf="enableCustomColor">
        <div class="col-5 mt-2">
          <div
            class="input-group offcanvas-border-primary border rounded-2"
            title="Using format option"
          >
            <input
              type="text"
              id="bg-color"
              class="form-control input-lg offcanvas-primary border-0"
              (change)="colorChange($event, true)"
              [value]="labelColor"
              [readOnly]="!enableCustomColor"
            />
            <span class="input-group-text p-1 border-0 offcanvas-primary">
              <span
                class="input-group-text colorpicker-input-addon h-100"
                [style.background]="labelColor"
                [cpOutputFormat]="'hex'"
                [(colorPicker)]="labelColor"
                [cpPosition]="'auto'"
                (colorPickerChange)="colorChange($event, false)"
                [cpDisabled]="!enableCustomColor"
              >
              </span>
            </span>
          </div>
        </div>
        <div class="col-4 mt-2">
          <div
            class="d-flex align-items-center justify-content-between flex-row-reverse h-100"
            *ngIf="colorObject"
          >
            <div
              tooltip="Color"
              class="rounded-circle d-flex align-items-center justify-content-center"
              [style]="
                'background-color:' +
                (light ? colorObject.light.color : colorObject.dark.color) +
                ';height: 20px; width: 20px;'
              "
              (click)="selectColor('color')"
            >
              <i
                *ngIf="selectedColor === 'color'"
                [class]="
                  builderService?.getIcon('done').type == 'mir'
                    ? 'material-icons-outlined'
                    : 'material-icons'
                "
                [style]="
                  'font-size: 12px; color:' +
                  (light ? colorObject.light.onColor : colorObject.dark.onColor)
                "
                >done</i
              >
            </div>
            <div
              tooltip="onColor"
              class="rounded-circle d-flex align-items-center justify-content-center"
              [style]="
                'background-color:' +
                (light ? colorObject.light.onColor : colorObject.dark.onColor) +
                ';height: 20px; width: 20px;'
              "
              (click)="selectColor('onColor')"
            >
              <i
                *ngIf="selectedColor === 'onColor'"
                [class]="
                  builderService?.getIcon('done').type == 'mir'
                    ? 'material-icons-outlined'
                    : 'material-icons'
                "
                [style]="
                  'font-size: 12px; color:' +
                  (light ? colorObject.light.color : colorObject.dark.color)
                "
                >done</i
              >
            </div>
            <div
              tooltip="colorContainer"
              class="rounded-circle d-flex align-items-center justify-content-center"
              [style]="
                'background-color:' +
                (light
                  ? colorObject.light.colorContainer
                  : colorObject.dark.colorContainer) +
                ';height: 20px; width: 20px;'
              "
              (click)="selectColor('colorContainer')"
            >
              <i
                *ngIf="selectedColor === 'colorContainer'"
                [class]="
                  builderService?.getIcon('done').type == 'mir'
                    ? 'material-icons-outlined'
                    : 'material-icons'
                "
                [style]="
                  'font-size: 12px; color:' +
                  (light
                    ? colorObject.light.onColorContainer
                    : colorObject.dark.onColorContainer)
                "
                >done</i
              >
            </div>
            <div
              tooltip="onColorContainer"
              class="rounded-circle d-flex align-items-center justify-content-center"
              [style]="
                'background-color:' +
                (light
                  ? colorObject.light.onColorContainer
                  : colorObject.dark.onColorContainer) +
                ';height: 20px; width: 20px;'
              "
              (click)="selectColor('onColorContainer')"
            >
              <i
                *ngIf="selectedColor === 'onColorContainer'"
                [class]="
                  builderService?.getIcon('done').type == 'mir'
                    ? 'material-icons-outlined'
                    : 'material-icons'
                "
                [style]="
                  'font-size: 12px; color:' +
                  (light
                    ? colorObject.light.colorContainer
                    : colorObject.dark.colorContainer)
                "
                >done</i
              >
            </div>
          </div>
        </div>
        <div
          class="col-3 text-start mt-2 d-flex align-items-center justify-content-end"
        >
          <span
            class="offcanvas-danger-text enablePointer"
            (click)="toggle(false)"
          >
            Remove
          </span>
        </div>
      </ng-container>
    </div>
    <div
      *ngIf="config?.setGradient"
      class="row align-items-center position-relative"
      [class.mt-4]="config?.text"
    >
      <label
        for="bg-color"
        class="offcanvas-header-text col-9 m-0"
        style="text-align: left"
        [ngStyle]="{ opacity: !enableBg ? '0.5' : '1' }"
      >
        Background Gradient
      </label>
      <div
        *ngIf="!enableCustomGradientColor && enableBg"
        class="col-3 d-flex justify-content-end"
      >
        <btn class="btn btn-primary" (click)="toggleGradientColor(true)"
          >SET</btn
        >
      </div>
      <div
        *ngIf="enableCustomGradientColor && enableBg"
        class="col-3 text-start mt-2 d-flex align-items-center justify-content-end"
      >
        <span
          class="offcanvas-danger-text enablePointer"
          (click)="toggleGradientColor(false)"
        >
          Remove
        </span>
      </div>

      <div
        *ngIf="!enableBg"
        class="col-3 text-start d-flex align-items-center justify-content-end offcanvas-header-text"
        style="font-size: 12; font-weight: 400"
      >
        Disabled
      </div>
      <ng-container *ngIf="enableCustomGradientColor">
        <div class="col-6 mt-2">
          <div
            class="input-group offcanvas-border-primary border rounded-2"
            title="Using format option"
          >
            <input
              type="text"
              id="bg-color"
              class="form-control input-lg offcanvas-primary border-0"
              (change)="startColorChange($event, true, 'color')"
              [value]="startColor"
              [readOnly]="!enableCustomGradientColor || !enableBg"
              [disabled]="!enableCustomGradientColor || !enableBg"
            />
            <span class="input-group-text p-1 border-0 offcanvas-primary">
              <span
                class="input-group-text colorpicker-input-addon h-100"
                [style.background]="startColor"
                [cpOutputFormat]="'hex'"
                [(colorPicker)]="startColor"
                [cpPosition]="'auto'"
                (colorPickerChange)="startColorChange($event, false, 'color')"
                [cpDisabled]="!enableCustomGradientColor || !enableBg"
              >
              </span>
            </span>
          </div>
        </div>
        <div class="col-6 mt-2">
          <div
            class="input-group offcanvas-border-primary border rounded-2"
            title="Using format option"
          >
            <input
              type="text"
              id="bg-color"
              class="form-control input-lg offcanvas-primary border-0"
              (change)="endColorChange($event, true, 'color')"
              [value]="endColor"
              [readOnly]="!enableCustomGradientColor || !enableBg"
              [disabled]="!enableCustomGradientColor || !enableBg"
            />
            <span class="input-group-text p-1 border-0 offcanvas-primary">
              <span
                class="input-group-text colorpicker-input-addon h-100"
                [style.background]="endColor"
                [cpOutputFormat]="'hex'"
                [(colorPicker)]="endColor"
                [cpPosition]="'auto'"
                (colorPickerChange)="endColorChange($event, false, 'color')"
                [cpDisabled]="!enableCustomGradientColor || !enableBg"
              >
              </span>
            </span>
          </div>
        </div>
      </ng-container>
    </div>
    <div
      *ngIf="config?.divider"
      class="form-check d-flex align-items-center p-0"
    >
      <label for="formReply" class="offcanvas-header-text w-100 m-0">
        Divider
      </label>
      <input
        type="checkbox"
        id="formReply"
        class="form-check-input offcanvas-border-primary offcanvas-primary me-2"
        style="width: 18px; height: 18px"
        [checked]="divider"
        (change)="toggleDivider($event)"
      />
    </div>
    <div class="row mb-3" *ngIf="config?.density">
      <div class="col-12 w-100 d-flex flex-column align-items-start">
        <label class="offcanvas-header-text" style="text-align: left">
          Density
        </label>
        <div
          class="btn-group"
          role="group"
          aria-label="Basic radio toggle button group"
        >
          <input
            type="radio"
            class="btn-check offcanvas-btn-check"
            [name]="'btnradiofont' + button?.button_id + densityID"
            [id]="'font3' + button?.button_id + densityID"
            autocomplete="off"
            [checked]="density === 0"
            (change)="updateSegmentHeight(0)"
          />
          <label class="btn" [for]="'font3' + button?.button_id + densityID"
            >Default</label
          >
          <input
            type="radio"
            class="btn-check offcanvas-btn-check"
            [name]="'btnradiofont' + button?.button_id + densityID"
            [id]="'font1' + button?.button_id + densityID"
            autocomplete="off"
            [checked]="density === -1"
            (change)="updateSegmentHeight(-1)"
          />
          <label class="btn" [for]="'font1' + button?.button_id + densityID"
            >Compact</label
          >
          <input
            type="radio"
            class="btn-check offcanvas-btn-check"
            [name]="'btnradiofont' + button?.button_id + densityID"
            [id]="'font2' + button?.button_id + densityID"
            autocomplete="off"
            [checked]="density === -2"
            (change)="updateSegmentHeight(-2)"
          />
          <label class="btn" [for]="'font2' + button?.button_id + densityID"
            >Dense</label
          >
          <input
            type="radio"
            class="btn-check offcanvas-btn-check"
            [name]="'btnradiofont' + button?.button_id + densityID"
            [id]="'font4' + button?.button_id + densityID"
            autocomplete="off"
            [checked]="density === -3"
            (change)="updateSegmentHeight(-3)"
          />
          <label class="btn" [for]="'font4' + button?.button_id + densityID"
            >Very Dense</label
          >
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #selectorIcons let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="selector">
      {{ iconType ? "Choose Trailing Icon" : "Choose Leading Icon" }}
    </h5>
    <button
      type="button"
      class="btn-close"
      data-bs-dismiss="modal"
      aria-label="Close"
      (click)="modalRef?.hide()"
    ></button>
  </div>
  <div class="modal-body">
    <app-icons-selector
      (selectedIcon)="iconChange($event)"
    ></app-icons-selector>
  </div>
</ng-template>
